import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitLanding(props) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-landing" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Don’t miss out!</h4>
          <p className="mb-0">
            Dr. Mimi Guarneri is one of the top holistic cardiologists on the planet. She’s “cracked the code” on how to
            prevent and even reverse the world’s #1 killer!
          </p>
          <Button className="btn-exit text-uppercase text-white text-h5" color="cta" onClick={toggle} block>
            Join the <br className="d-none d-lg-block d-xl-none" />
            Masterclass NOW
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div className="exit-modal-image background-image-1329993240" />
        </Col>
      </Row>
    </Modal>
  );
}
